export class DashboardDM {
  constructor({ featured = {}, latest = {}, promo = {} }) {
    this.featured = featured;
    this.latest = latest;
    this.promo = promo;
  }

  toJson() {
    return {
      featured: this.featured,
      latest: this.latest,
      promo: this.promo,
    };
  }

  static fromJson(json) {
    return new DashboardDM({
      featured: json["featured"],
      latest: json["latest"],
      promo: json["promo"],
    });
  }
}
